import { APIClient } from '../helpers/api_helper';
const AxiosClient = new APIClient()

const products = payload => AxiosClient.post('/products', payload);
// const product_value = payload => AxiosClient.post('/products-value', payload);
const requisition_create = payload => AxiosClient.post('/create-requisition', payload);
const user_requisition = payload => AxiosClient.get('/requisition-history', payload);
const filter_requistion = payload=> AxiosClient.get('/requisition-history',payload);
const item_details = payload=> AxiosClient.post('/requisition-item-details',payload);
const user_filter = payload=> AxiosClient.post('/filter-record',payload);
const requisition_summary = ()=> AxiosClient.get('/requisition-count');
const child_employees = ()=> AxiosClient.get('/childs');
const child_employees_of_purchase_manager = ()=> AxiosClient.get('/purchase-manager-childs');
const purchase_manager_product_approval_list = () => AxiosClient.get('/purchase-all-product-approval-list');
const purchase_manager_pending_product_approval_list = () => AxiosClient.get('/purchase-pending-approval-list');
const purchase_product_wise_approval = (item_no) => AxiosClient.get(`/purchase-product-wise-approval-list/${item_no}`)
const purchase_product_wise_saved_approval = (item_no) => AxiosClient.get(`/purchase-product-wise-saved-approval-list/${item_no}`)
const management_approved_list = (payload) => AxiosClient.post('/management-approved-list', payload);

const modify_product_quantity = (payload) => AxiosClient.post('/modify-product-quantity', payload);
const getStockInHand = (payload)=> AxiosClient.post('/item-stock-in-hand', payload);
const fetchVendorWiseProduct = (vendor_id_with_date) => AxiosClient.get(`/vendor-wise-approved-product-list/${vendor_id_with_date}`);

const management_approval_list = (payload) =>  AxiosClient.post('/management-approval-list', payload);
const detailed_approval_list = (vendor_id_with_date) => AxiosClient.get(`/detailed-management-approval-list/${vendor_id_with_date}`);
const management_approve_product = (payload) =>  AxiosClient.post('/management-approve-product-in-process', payload);
const managementApprovalHistoryList = (payload) => AxiosClient.post('/management-approval-history-list', payload);

const managementApprovalPendingList = (vendor_id_with_date) => AxiosClient.get(`/detailed-management-approval-in-process-list/${vendor_id_with_date}`);
const submitManagementApproval = (payload) =>  AxiosClient.post('/management-approve-product', payload);

export {
    products,
    // product_value,
    requisition_create,
    user_requisition,
    user_filter,
    filter_requistion,
    item_details,
    requisition_summary,
    child_employees,
    child_employees_of_purchase_manager,
    purchase_manager_product_approval_list,
    purchase_manager_pending_product_approval_list,
    purchase_product_wise_approval,
    purchase_product_wise_saved_approval,
    modify_product_quantity,
    getStockInHand,
    management_approval_list,
    detailed_approval_list,
    management_approve_product,
    managementApprovalHistoryList,
    management_approved_list,
    fetchVendorWiseProduct,
    managementApprovalPendingList,
    submitManagementApproval
}